export const checkForNonEmptyValue = value => {
  if (Array.isArray(value) && value.length) {
    return '';
  }
  if (typeof value === 'string' && value.trim().length) {
    return '';
  }
  return "This is a mandatory field";
};
export const checkForNonSelectedValue = value => {
  if (value === undefined) {
    return "This is a mandatory field";
  }
  return '';
};
export const checkRequiredValidLink = value => {
  let url;
  const errorString = "URL should be in the format of https:// and exclude invalid characters, spaces, or symbols.";
  try {
    url = new URL(value);
  } catch (_unused) {
    return errorString;
  }
  const isValid = url.protocol === 'https:';
  return !isValid ? errorString : '';
};
export const checkValidLink = value => {
  if (!value) {
    return '';
  }
  return checkRequiredValidLink(value);
};
export const checkForValidEmail = value => {
  const emptyValueError = checkForNonEmptyValue(value);
  if (emptyValueError) {
    return emptyValueError;
  }
  const validEmailPattern = /^[a-zA-Z0-9.#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isEmailValid = validEmailPattern.test(value);
  if (!isEmailValid) {
    return 'This is not a valid email';
  }
  return '';
};
export const checkForNonNegativeNumber = value => {
  if (typeof value === 'number') {
    if (value >= 0 && value < Number.MAX_SAFE_INTEGER) {
      // check for decimal value
      if (value % 1 != 0) {
        return 'Please only enter whole numbers';
      }
      return '';
    }
    return 'This is out of range';
  }
  return "This is a mandatory field";
};
export const checkForMaxRetentionValue = (value, formState) => {
  var _formState$dataRetent;
  const emptyValueError = checkForNonNegativeNumber(value);
  if (emptyValueError) {
    return emptyValueError;
  }
  if (value <= ((_formState$dataRetent = formState.dataRetention) === null || _formState$dataRetent === void 0 ? void 0 : _formState$dataRetent.retentionDurationInDays.min)) {
    return 'Maximum storage period must be greater than minimum storage period';
  }
  return '';
};